export default class Select {
  constructor(component) {
    this.el = component.el;
    this.$el = $(this.el);

    this.$el.on('change', () => this.updateSelectText());

    if (!this.$el.parent('.select-wrapper').length && !this.$el.hasClass('product-variants') && !this.$el.hasClass('select-disable-wrapper')) {
      this.$el.wrap("<div class='select-wrapper' />").parent().prepend("<span class='selected-text'></span>");
    }

    this.updateSelectText();
  }

  updateSelectText() {
    const newOption = this.$el.find('option:selected').prop('selected', true).text();
    if (newOption) {
      this.$el.siblings('.selected-text').text(newOption);
    }
  }
}
